
import { Button } from '@/components/ui/button';
import { AlertCircle, ArrowLeft } from 'lucide-react';

interface YouTubeAuthErrorProps {
  errorMessage: string;
  onRetry: () => void;
  onCancel: () => void;
}

const YouTubeAuthError = ({ 
  errorMessage, 
  onRetry, 
  onCancel 
}: YouTubeAuthErrorProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
      <div className="p-4 border-b border-gray-100 flex items-center">
        <Button variant="ghost" size="icon" onClick={onCancel} className="mr-2">
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h2 className="text-lg font-medium">YouTube Authentication</h2>
      </div>
      
      <div className="p-6">
        <div className="flex flex-col items-center justify-center py-8">
          <div className="flex items-center justify-center bg-red-100 p-6 rounded-full mb-6">
            <AlertCircle className="h-8 w-8 text-red-600" />
          </div>
          
          <h3 className="text-xl font-medium mb-2 text-center">Error Connecting YouTube</h3>
          <p className="text-gray-600 mb-8 text-center max-w-md">
            {errorMessage || "There was an error connecting to YouTube. Please try again."}
          </p>
          
          <div className="flex space-x-4">
            <Button
              variant="outline"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              onClick={onRetry}
            >
              Try Again
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YouTubeAuthError;
